export default __webpack_public_path__ + "static/media/nftsell.aaebec5d.gif";